<template>
  <div>
    <p>{{ $t('whatsapp-modal-content') }}</p>
    <form method="post" @submit.prevent="contactHost">
      <div class="form-group">
      <textarea name="message" id="message" class="form-control"
                required
                v-model="message" rows="5" :placeholder="$t('whatsapp-first-message')"></textarea>

      </div>

      <div class="form-group input-icon-box my-3" @click="showDatePicker">
        <label for="detail_contact_date_range">
          <button class="btn btn-first" type="button">
            <TyIcon icon="ty-calendar" width="1rem"/>
          </button>
        </label>
        <input type="text" name="date_range" id="detail_contact_date_range" class="form-control"
               :placeholder="$t('choose-date-of-trip')" readonly v-model="dateText">
      </div>

      <LazyDateRangePicker
          v-if="reservationCalendarPopup"
          :minDate="(new Date()).setHours(1)"
          :minDuration="1" :alwaysUnder="true"
          :startDate="(arrivalDate && arrivalDate !== leaveDate)  ? datePickerCurrentDates.startDate : null"
          :disabled_dates="[]"
          :date_range="datePickerCurrentDates"
          @onSelect="afterDateRangeSelect"/>

      <button class="btn btn-whatsapp my-3 btn-rounded" type="submit">
        {{ $t('send-message') }}
      </button>
    </form>
  </div>
</template>

<script setup lang="ts">

import {PropType, ref, computed} from "vue";
import Accommodation from "../../../../../lib/models/Accommodation";
import {useNuxtApp} from "#app";
import {GATracker} from "../../../../../composables/ga_tracker";
import {obtainActiveLocale, tyrionResponse} from "#imports";
import LazyDateRangePicker from "../../../parts/calendar/calendar_range_picker_double.vue";
import dayjs from "dayjs";
import {formatTime} from "../../../../../lib/functions";

const {GATrackEvent} = GATracker();
const activeLocale = obtainActiveLocale();
const {$i18n, $tyrionApi} = useNuxtApp();

const props = defineProps({
  accommodation: Object as PropType<Accommodation>
});

const message = ref<string>("");
const reservationCalendarPopup = ref<boolean>(false);
const arrivalDate = ref('2021-01-01');
const leaveDate = ref('2021-01-01');

const dateText = computed(() => {
  return arrivalDate.value !== leaveDate.value ? `${(new Date(arrivalDate.value)).toLocaleDateString()} - ${(new Date(leaveDate.value)).toLocaleDateString()}` : "";
});

const datePickerCurrentDates = computed(() => {
  return {startDate: dayjs(arrivalDate.value).hour(9), endDate: dayjs(leaveDate.value).hour(9)}
});

const afterDateRangeSelect = (dateRange) => {
  arrivalDate.value = formatTime(dateRange.startDate, 'YYYY-MM-DD');
  leaveDate.value = formatTime(dateRange.endDate, 'YYYY-MM-DD');
  reservationCalendarPopup.value = false;
};

const contactHost = () => {
  const whatsAppContact = props.accommodation.contacts.find(c => c.hasWhatsappNumber);
  const url = `https://wa.me/${whatsAppContact.whatsapp.substring(1)}?text=${encodeURIComponent($i18n.t('whatsapp-contact-message-start') + ". " + message.value + (arrivalDate.value != leaveDate.value ? `. ${(new Date(arrivalDate.value)).toLocaleDateString()} - ${(new Date(leaveDate.value)).toLocaleDateString()}. ` : '. ') + `${window.location.href}`)}`;


  GATrackEvent({
    event: 'whatsapp_message',
    language: activeLocale.code,
    action: 'click',
    label: 'Contact host on whatsapp',
    value: props.accommodation.link,
    items: [
      {
        item_id: props.accommodation.id,
        item_name: props.accommodation.title,
        item_category: props.accommodation.category,
        currency: props.accommodation.main_currency,
        item_variant: props.accommodation.location.tourist_region.code
      }
    ]
  }, 700);

  window.open(url, '_blank');

}


const showDatePicker = () => {
  reservationCalendarPopup.value = true;
};


</script>
